import React from "react"
import Paper from "@mui/material/Paper"
import { AlertTriangle, X } from "lucide-mui"
import { Dialog } from "@mui/material"
import { useQuery } from "@apollo/client/react"
import { GetCustomerByContactDocument } from "@/graphql/graphql"
import IconButton from "@mui/material/IconButton"
import i18n from "@/i18n"
import Tabs from "./tabs"
import CustomerDetails from "./customer_details"
import Loading from "./loading"

const STYLES = {
  errorContainer: "inset-0 flex items-center justify-center",
  errorPaper: "text-center p-4 flex flex-col items-center",
  errorIcon: "block text-8xl text-red-600 mb-4",
  errorText: "text-red-600",
  dialogPaper: "max-w-4xl w-[calc(100%-64px)] max-h-[90vh] flex flex-col",
  content: "flex flex-1 min-h-[50vh]",
  leftPanel: "flex flex-col bg-gray-50 p-6",
  rightPanel: "flex flex-col flex-1 relative min-h-0",
  closeButtonContainer: "absolute top-2 right-2 z-10",
  closeIcon: "text-lg",
}

const Error = () => (
  <div data-testid="panel-clients-modal-error" className={STYLES.errorContainer}>
    <Paper className={STYLES.errorPaper}>
      <AlertTriangle fontSize="inherit" className={STYLES.errorIcon} />
      <div className={STYLES.errorText}>{i18n.t("app.clients.client_modal.error_not_found")}</div>
    </Paper>
  </div>
)

const ClientModal = ({ customerContactId, onClose }) => {
  const { data, loading, error } = useQuery(GetCustomerByContactDocument, {
    variables: { customerContactId },
    skip: !customerContactId,
  })
  const customer = data?.business?.customer
  const customerContact = customer?.customerContacts.find((c) => c.id === customerContactId)

  const isLoading = !customer && loading
  const hasError = error || customer === null

  return (
    <Dialog
      open={!!customerContactId}
      onClose={onClose}
      slotProps={{
        paper: {
          className: STYLES.dialogPaper,
        },
      }}
    >
      {isLoading && <Loading onClose={onClose} />}
      {hasError && <Error />}
      {!isLoading && !hasError && customer && customerContact && (
        <div data-testid="panel-clients-modal-content" className={STYLES.content}>
          <div data-testid="panel-clients-modal-left-panel" className={STYLES.leftPanel} style={{ flex: "0 0 30%" }}>
            <CustomerDetails customer={customer} customerContact={customerContact} />
          </div>

          <div data-testid="panel-clients-modal-right-panel" className={STYLES.rightPanel} style={{ flex: "0 0 70%" }}>
            <div className={STYLES.closeButtonContainer}>
              <IconButton data-testid="panel-clients-modal-close" onClick={onClose} color="inherit" size="small">
                <X className={STYLES.closeIcon} />
              </IconButton>
            </div>

            <Tabs customer={customer} customerContact={customerContact} />
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default ClientModal
